export default {
  customers: {
    title: 'All Customers',
    total: 'Total',
    search: 'Search',
    filters: 'Filters',
    export: 'Export',
    resetAll: 'Reset All',
    status: {
      all: 'All Statuses',
      active: 'Active',
      inactive: 'Inactive',
      suspended: 'Suspended'
    },
    kyc: {
      all: 'All',
      verified: 'Verified',
      unverified: 'Unverified'
    },
    details: {
      general: 'General Information',
      referredBy: 'Referred By',
      noReferrer: 'No Referrer',
      loading: 'Loading...',
      // ... többi fordítás
    },
    deleteSuccess: "Customer successfully deleted",
    deleteError: "Error deleting customer",
    deleteConfirmTitle: "Delete Customer",
    deleteConfirmMessage: "Are you sure you want to delete customer: ${name}?",
    unknownCustomer: "Unknown Customer",
    noResults: "No results found for the search criteria.",
    title: "Customers",
    total: "Total",
    search: "Search...",
    filters: "Filters",
    export: "Export",
    resetAll: "Reset Filters",
    status: {
      all: "Status",
      new: "New Partner",
      active: "Active",
      inactive: "Inactive"
    }
  },
  customerDetails: {
    title: 'Customer Details',
    tabs: {
      information: 'Information',
      investments: 'Investments',
      earnings: 'Earnings',
      transactions: 'Transactions',
      referral: 'Referral Tree',
      referralEdit: 'Edit Referral',
      tickets: 'Tickets'
    },
    basicInfo: {
      title: 'Basic Information',
      username: 'Username',
      email: 'Email',
      country: 'Country',
      status: 'Status',
      createdAt: 'Created At',
      migratedAt: 'Migrated At',
      migratedFrom: 'Migrated From'
    },
    financialInfo: {
      title: 'Financial Information',
      accountBalance: 'Account Balance',
      totalProfit: 'Total Profit',
      totalDeposit: 'Total Deposit',
      totalInvestment: 'Total Investment',
      activePlans: 'Active Plans',
      features: {
        deposits: 'Deposits',
        withdrawals: 'Withdrawals',
        transfers: 'Transfers'
      }
    },
    transactions: {
      title: 'Transaction History',
      date: 'Date',
      type: 'Type',
      amount: 'Amount',
      method: 'Method',
      status: 'Status',
      id: 'ID'
    },
    referral: {
      title: 'Referral Network',
      stats: {
        total: 'Total Referrals',
        active: 'Active Referrals',
        volume: 'Total Volume'
      }
    },
    investments: {
      totalInvested: 'Total Invested',
      activeInvestments: 'Active Investments',
      totalProfit: 'Total Profit',
      plan: 'Investment Plan',
      amount: 'Amount',
      profit: 'Profit',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status'
    },
    earnings: {
      totalEarnings: 'Total Earnings',
      thisMonth: 'This Month',
      lastPayout: 'Last Payout',
      byType: 'Earnings by Type',
      date: 'Date',
      type: 'Type',
      amount: 'Amount',
      status: 'Status'
    },
    tickets: {
      title: 'Tickets',
      total: 'Total Tickets',
      open: 'Open Tickets',
      avgResponseTime: 'Avg. Response Time',
      table: {
        id: 'Ticket ID',
        subject: 'Subject',
        department: 'Department',
        priority: 'Priority',
        status: 'Status',
        lastUpdate: 'Last Update'
      },
      priority: {
        low: 'Low',
        normal: 'Normal',
        high: 'High'
      },
      department: {
        support: 'General Support',
        technical: 'Technical Support',
        billing: 'Billing'
      },
      status: {
        open: 'Open',
        pending: 'Pending',
        closed: 'Closed'
      },
      noTickets: 'No tickets found',
      createNew: 'Create New Ticket'
    },
    quickActions: {
      sendEmail: 'Send Email',
      newTicket: 'New Ticket',
      more: 'More Actions',
      exportPDF: 'Export PDF'
    },
    status: {
      active: 'Active',
      suspended: 'Suspended',
      inactive: 'Inactive',
      kycVerified: 'KYC Verified',
      kycRequired: 'KYC Required',
      twoFaEnabled: '2FA Enabled'
    },
    fields: {
      phone: 'Phone',
      city: 'City',
      joined: 'Joined',
      migrationInfo: 'Migrated from legacy system',
      notAvailable: 'N/A'
    },
    updateSuccess: 'Customer details updated successfully',
    updateError: 'Failed to update customer details'
  },
  navbar: {
    beta: 'This is a beta environment. Data and features are under testing.',
    menu: {
      dashboard: 'Dashboard',
      projects: {
        title: 'Projects',
        all: 'All Projects',
        archived: 'Archived',
        deleted: 'Deleted'
      },
      customers: {
        title: 'Customers',
        all: 'All Customers',
        notifications: 'Send Notifications',
        referrals: 'Referrals',
        referralTree: 'Referral Tree'
      },
      discounts: {
        title: 'Discounts',
        all: 'All discounts',
        categories: 'Manage Categories'
      },
      system: {
        title: 'System',
        pages: 'Pages',
        emailTemplates: 'Email Templates',
        smsTemplates: 'SMS Templates',
        pushNotifications: 'Push Notifications',
        subscribers: 'Subscribers',
        customCss: 'Custom CSS',
        clearCache: 'Clear Cache',
        appInfo: 'App Info',
        landingPage: 'Landing Page',
        logs: 'Activity Logs'
      },
      staff: {
        title: 'Staff',
        roles: 'Roles'
      },
      wallet: {
        title: 'Wallet',
        all: 'Users',
        transactions: 'Transactions',
        transfers: 'Transfers'
      }
    }
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overview of your platform\'s performance and key metrics',
    stats: {
      totalCustomers: 'Total Customers',
      activeCustomers: 'Active Customers',
      totalVolume: 'Total Volume',
      totalInvestments: 'Total Investments',
      pendingKyc: 'Pending KYC',
      openTickets: 'Open Tickets',
      fromLastMonth: 'from last month'
    },
    quickActions: {
      title: 'Quick Actions',
      manageCustomers: 'Manage Customers',
      reviewKyc: 'Review KYC',
      viewInvestments: 'View Investments',
      supportTickets: 'Support Tickets'
    },
    availableDiscounts: 'Available Discounts',
    noDiscounts: 'No discounts available',
    checkBackLater: 'Check back later for new discounts',
    viewDiscount: 'View Discount',
    welcome: 'Welcome to Előny Club!',
    discountInfo: 'As a member of Előny Club, you have access to exclusive discounts on various services and products. All discounts come from our verified partners.',
    benefits: {
      exclusive: 'Exclusive discounts for club members only',
      verified: 'Verified partners and reliable offers',
      updated: 'Continuously updated discounts and new opportunities'
    }
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    search: 'Search customers...',
    showing: 'Showing',
    of: 'of',
    copied: 'Copied!',
    create: 'Create',
    confirmBatchOperation: 'Are you sure you want to perform this operation on {{count}} items?',
    batchOperationSuccess: 'Successfully modified {{count}} items',
    batchOperationError: 'Error performing batch operation',
    itemsSelected: 'items selected',
    activate: 'Activate',
    deactivate: 'Deactivate',
    delete: 'Delete'
  },
  referralManager: {
    title: 'Referral Manager',
    subtitle: 'Manage customer referral relationships',
    currentReferrer: 'Current Referrer',
    updateReferrer: 'Update Referrer',
    selectReferrer: 'Select new referrer',
    noReferrer: 'No referrer',
    totalCustomers: 'Total Customers',
    withReferrer: 'With Referrer',
    noOptions: 'No options found',
    updateSuccess: 'Referrer updated: {{username}} → {{referrer}}',
    updateError: 'Failed to update referrer',
    treeEditor: 'Referral Tree Editor',
    treeEditorSubtitle: 'Edit referral relationships using text representation',
    treeStructure: 'Tree Structure',
    treeInstructions: 'Use spaces to indent child relationships. Format: username (ID: number)',
    resetTree: 'Reset Tree',
    invalidFormat: 'Invalid format in line: {{line}}',
    duplicateId: 'Duplicate ID found: {{id}}',
    fetchError: 'Failed to load customers',
    dragDropInstruction: 'Drag and drop users to update referral relationships',
    invalidMove: 'Cannot move a user under itself or its referrals',
    filtered: 'Filtered Results',
    searchPlaceholder: 'Search by name, username, email or ID...',
    averageTeamSize: 'Average Team Size',
    deepestChain: 'Deepest Chain',
    topReferrers: 'Top Referrers',
    members: 'members',
    removeReferrer: 'Remove Referrer',
    noReferrerFilter: 'Without Referrer',
    lastWeek: '7 days',
    lastMonth: '30 days',
    last3Months: '90 days',
    allTime: 'All time',
    removeSuccess: 'Referrer removed for {{username}}',
    unknownReferrer: 'Unknown Referrer'
  },
  register: {
    title: 'Register',
    referredBy: 'Referred by:',
    secure: 'Your information is secure and encrypted',
    verifyingReferral: 'Sorry, this referral code does not exist or has expired',
    form: {
      username: 'Username',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      firstName: 'First Name',
      lastName: 'Last Name',
      submit: 'Register',
      usernameWarning: 'Username cannot be changed later'
    },
    errors: {
      invalidReferral: 'Invalid Referral Link',
      checkReferral: 'The referral code you are trying to use is invalid or has expired. Please check your link and try again.',
      directRegistration: 'Direct registration is not allowed',
      passwordMismatch: 'Passwords do not match',
      emailExists: 'Email is already registered',
      usernameTaken: 'Username is already taken',
      verificationFailed: 'Failed to verify referral',
      registrationFailed: 'Registration failed. Please try again.',
      authDisabled: 'Registration is temporarily disabled. Please try again later.',
      weakPassword: 'Password should be at least 6 characters long'
    }
  },
  referral: {
    title: 'Referral Link',
    information: 'Referral Information',
    code: 'Referral Code',
    link: 'Referral Link',
    description: 'Share your referral link and build your team!',
    linkCopied: 'Link copied!',
    copyError: 'Failed to copy link',
    usernameError: 'Error fetching username',
    shareEmail: 'Share via email',
    emailSubject: 'Join me!',
    emailBody: 'Hi! Join me using this link: {link}',
    whatsappMessage: 'Hi! Join me using this link: {link}',
    stats: {
      totalReferrals: 'Total Referrals',
      activeReferrals: 'Active Referrals',
      totalEarnings: 'Total Earnings'
    }
  },
  user: {
    dashboard: {
      title: 'Control Panel',
      balance: {
        title: 'Balance',
        available: 'Available Balance',
        total: 'Total Balance',
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        lastUpdate: 'Last update'
      },
      investments: {
        title: 'Investments',
        active: 'Active Investments',
        total: 'Total Invested',
        recent: 'Recent Investments',
        daysLeft: 'days left',
        noActive: 'No active investments',
        startNew: 'Start investing now',
        viewAll: 'View all investments'
      },
      profits: {
        title: 'Profits',
        statistics: 'Profit Statistics',
        today: 'Today',
        thisMonth: 'This Month',
        total: 'Total Profit',
        totalAmount: 'Total Profit: {{amount}} NFU'
      },
      quickActions: {
        title: 'Quick Actions',
        deposit: 'Make Deposit',
        invest: 'New Investment',
        withdraw: 'Withdraw',
        referral: 'Invite Friends'
      }
    }
  },
  nav: {
    dashboard: 'Dashboard',
    investments: 'Investments',
    support: 'Support'
  },
  profile: {
    menu: {
      title: 'Open user menu',
      profile: 'Profile',
      signOut: 'Sign Out'
    }
  },
  projects: {
    selectType: 'Select type',
    selectStatus: 'Select status',
    form: {
      name: 'Project name',
      type: 'Type',
      status: 'Status',
      customer: 'Customer',
      color: 'Color',
      notes: 'Notes',
      contractNumber: 'Contract number',
      language: 'Language',
      payment: {
        nftCount: 'NFT count',
        splitPayment: 'Split payment',
        nftValueUSDT: 'NFT value (USDT)',
        currency: 'Currency',
        paymentType: 'Payment type',
        paymentMethod: 'Payment method',
        amount: 'Amount'
      }
    }
  },
  discounts: {
    management: 'Discount Management',
    new: 'New Discount',
    edit: 'Edit Discount',
    title: 'Title',
    description: 'Description',
    percentage: 'Discount Percentage (%)',
    logo: 'Logo',
    link: 'Link',
    active: 'Active Discount',
    cancel: 'Cancel',
    save: 'Save',
    deleteConfirm: 'Are you sure you want to delete this discount?',
    success: {
      created: 'Discount successfully created',
      updated: 'Discount successfully updated',
      deleted: 'Discount deleted'
    },
    error: {
      loading: 'Error loading discounts',
      saving: 'Error saving discount',
      deleting: 'Error deleting discount'
    }
  },
  login: {
    welcome: 'Welcome to Discount Club!',
    description: 'Discover exclusive discounts we provide for our members.',
    feature1: 'Exclusive discounts on selected services and products',
    feature2: 'Offers from trusted, verified partners',
    feature3: 'Continuously expanding discount offerings'
  }
}; 